import React, { Fragment, useEffect, useMemo, useState } from "react";

import useBusinessMenu from "src/query/useBusinessMenu";
import { isRacing } from "src/utils/functions";
import { BusinessMenuI } from "src/types/types";
import { capitalize } from "@mui/material";
import { useQuery } from "react-query";
import { useAppDispatch, useAppSelector } from "src/redux/redux-hooks";
import { getEventsByLeagueId, getLeaguesBySportId } from "src/api/commonApi";
import { setLeftBarGameId, setLeftBarLeagueId } from "src/redux/reducers/appSlice";
import { useNavigate } from "react-router-dom";

const closeSidebar = (e: React.SyntheticEvent) => {
  e.preventDefault();
  document.body.classList.remove("sidebar-enable");
};

const Sidebar: React.FC = () => {
  const { data } = useBusinessMenu({ enabled: false });

  const sportMenus = useMemo(() => {
    return Array.isArray(data)
      ? data.filter((item) => {
          return !isRacing(item.provider_game_id) && !item.is_casino ? true : false;
        })
      : [];
  }, [data]);

  return (
    <div className="vertical-menu">
      <div className="h-100" data-simplebar="">
        <div id="sidebar-menu">
          <ul id="side-menu" className="metismenu list-unstyled">
            <li id="event-tree" className="menu-box">
              <a href="#">
                <span>Sports</span>{" "}
                <i
                  role="button"
                  className="fa fa-times float-right"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      closeSidebar(e);
                    }
                  }}
                  onClick={closeSidebar}
                />
              </a>
              <ul className="sub-menu mm-collapse mm-show">
                {sportMenus.map((item, key) => (
                  <GameMenuItem key={key} menu={item} />
                ))}
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const GameMenuItem = ({ menu }: { menu: BusinessMenuI }) => {
  const dispatch = useAppDispatch();
  const { leftBarGameId } = useAppSelector((state) => state.app);

  const { data: leagues, refetch } = useQuery({
    queryFn: () => getLeaguesBySportId(leftBarGameId),
    enabled: false,
    queryKey: [`sport-leagues-data`, leftBarGameId],
    onError: () => {
      // console.error("Error Fetching Menu Data", error);
    },
  });

  useEffect(() => {
    if (leftBarGameId && leftBarGameId === menu.game_id) {
      refetch();
    }
  }, [leftBarGameId, menu.game_id]);

  return (
    <li>
      <span
        onClick={(e) => {
          e.stopPropagation();
          dispatch(setLeftBarGameId(menu.game_id === leftBarGameId ? null : menu.game_id));
        }}
      >
        {capitalize(menu.menu_name)} <b className="ml-1">{leftBarGameId === menu.game_id ? "-" : "+"}</b>
      </span>
      {leftBarGameId === menu.game_id && <GameLeagues menu={menu} leagues={leagues as any[]} />}
    </li>
  );
};

interface LeagueItemProps {
  league: {
    league_id: string;
    league_name: string;
  };
}

const GameLeagues = ({ menu, leagues }: { menu: BusinessMenuI; leagues: LeagueItemProps["league"][] }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { leftBarLeagueId } = useAppSelector((state) => state.app);
  console.log("🚀 ~ GameLeagues ~ leftBarLeagueId:", leftBarLeagueId);

  const { data: event, refetch } = useQuery({
    queryFn: () => getEventsByLeagueId(leftBarLeagueId),
    enabled: false,
    queryKey: [`league-event-data`, leftBarLeagueId],
    onError: () => {
      // console.error("Error Fetching Menu Data", error);
    },
  });
  console.log("🚀 ~ GameLeagues ~ event:", event);

  useEffect(() => {
    if (leftBarLeagueId) {
      refetch();
    }
  }, [leftBarLeagueId]);

  return (
    <Fragment>
      {Array.isArray(leagues) && leagues.length > 0 && (
        <ul className="sub-menu" style={{}}>
          {leagues.map((league) => (
            <li key={league.league_id}>
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setLeftBarLeagueId(league.league_id === leftBarLeagueId ? null : league.league_id));
                }}
              >
                {league.league_name} <b className="ml-1">{leftBarLeagueId === league.league_id ? "-" : "+"}</b>
              </span>
              {leftBarLeagueId === league.league_id && Array.isArray(event) && event.length > 0 && (
                <ul className="sub-menu" style={{}}>
                  {event.map((event) => (
                    <li
                      key={event.event_id}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/game/details/${menu.provider_game_id}/${event.game_event_id}`);
                        closeSidebar(e);
                      }}
                    >
                      <span>{event.event_name}</span>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
    </Fragment>
  );
};

export default Sidebar;
